
export { default as allPass } from "./allPass.js"
export { default as always } from "./always.js"
export { default as cond } from "./cond.js"
export { default as prop } from "./prop.js"
export { default as propEq } from "./propEq.js"